import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client'
import React, { FC } from 'react'
import { AUTH_SERVICE } from '../../Constants'

const GqlClient: FC = ({ children }): JSX.Element => {
  const client = new ApolloClient({
    cache: new InMemoryCache(),
    uri: AUTH_SERVICE
  })

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default GqlClient
